import React from 'react';
import { Link } from 'react-router-dom';
import DocsLayout from '../../components/docs/DocsLayout';
import SEO from '../../components/SEO';
import Breadcrumb from '../../components/docs/Breadcrumb';
import { SEO_CONFIG } from '../../config/seoConfig';

const tocItems = [
  { id: 'jan-2026', label: 'January 2026' },
];

const Changelog = () => {
  const seoConfig = SEO_CONFIG['/docs/changelog'];

  return (
    <DocsLayout tocItems={tocItems} activeTocItem="jan-2025">
      <SEO
        title={seoConfig.title}
        description={seoConfig.description}
        path="/docs/changelog"
      />
      <Breadcrumb items={seoConfig.breadcrumb} currentPath="/docs/changelog" />

      {/* Page Title */}
      <h1 className="text-3xl sm:text-4xl font-bold text-zinc-50 mb-4 tracking-tight">
        Changelog
      </h1>

      <p className="text-lg text-zinc-400 leading-relaxed mb-10 max-w-2xl">
        A record of notable changes, new features, and improvements to DayTradingBench.
      </p>

      {/* Section: January 2026 */}
      <section id="jan-2026" className="mb-12 scroll-mt-20">
        <h2 className="text-xl sm:text-2xl font-semibold text-zinc-50 mb-6 flex items-center gap-3">
          <span className="text-green-500">●</span>
          January 2026
        </h2>

        <div className="bg-dark-tertiary border border-dark-border rounded-xl p-6 mb-4">
          <div className="flex items-center gap-3 mb-3">
            <span className="px-2 py-1 text-xs rounded border bg-blue-500/10 text-blue-500 border-blue-500/30">
              In Development
            </span>
          </div>
          <div className="text-sm text-zinc-400 leading-relaxed">
            <p>
              DayTradingBench is currently in active development. The platform is being built
              to benchmark LLM trading capabilities using real market data and simulated positions.
            </p>
            <p className="mt-3 text-zinc-500">
              Official release notes will be published here once the platform launches publicly.
            </p>
          </div>
        </div>
      </section>

      {/* Navigation Footer */}
      <div className="flex justify-between pt-8 border-t border-dark-border mt-8">
        <Link
          to="/docs/faq"
          className="flex items-center gap-2 px-4 py-3 border border-dark-border rounded-lg
                     text-zinc-400 hover:text-zinc-200 hover:border-zinc-600 transition-colors"
        >
          <span>←</span>
          <div>
            <div className="text-[11px] text-zinc-600">Previous</div>
            <div className="text-zinc-50">FAQ</div>
          </div>
        </Link>
        <Link
          to="/docs"
          className="flex items-center gap-2 px-4 py-3 border border-dark-border rounded-lg
                     text-zinc-400 hover:text-zinc-200 hover:border-zinc-600 transition-colors"
        >
          <div className="text-right">
            <div className="text-[11px] text-zinc-600">Back to</div>
            <div className="text-zinc-50">Overview</div>
          </div>
          <span>→</span>
        </Link>
      </div>
    </DocsLayout>
  );
};

export default Changelog;
